import * as React from 'react';
import SearchWidget from 'app/pages/AgentSearch/components/SearchWidget';
import AgentItemsList from 'app/pages/AgentSearch/components/AgentItemsList';
import './Page.css'

export class Page extends React.Component {
    render() {
        return <div>
        <h1 id="agents-header">Commissions</h1>
            <div className="agent-list">
                <div className="ui stackable grid">
                    <div className="eleven wide column">
                        <SearchWidget />
                    </div>
                    <div className="five wide column">&nbsp;</div>
                </div>
                <AgentItemsList />
            </div>
        </div>;
    }

    componentDidMount() {
        if (!window.location.hash)
            return;

        let id = window.location.hash;
        if (id.startsWith('#'))
            id = id.substr(1);
        
        const element = document.getElementById(id);
        if (!element)
            return;

        const header = document.getElementById('agents-header');
        const headerClientRects = header ? header.getClientRects() : null;
        const headerClientRectItem = headerClientRects ? headerClientRects.item(0) : null;
        const offset = headerClientRectItem
            ? headerClientRectItem.top
            : 60;

        const clientRect = element.getClientRects();
        if (clientRect === null || clientRect.length == 0)
            return;

        const clientRectItem = clientRect.item(0);
        if (clientRectItem == null)
            return;

        let scrollPos = clientRectItem.top - offset;
        if (scrollPos < 0)
            scrollPos = 0;
        window.scrollTo(0, scrollPos);
    }
}